//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminCompanyController_removeUser,
  Response$AdminCompanyController_removeUser$Status$200,
  ResponseContentType$AdminCompanyController_removeUser,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminCompanyController_removeUser = () =>
  useApiClientMutation<
    Params$AdminCompanyController_removeUser,
    Response$AdminCompanyController_removeUser$Status$200[ResponseContentType$AdminCompanyController_removeUser]
  >({ method: 'AdminCompanyController_removeUser' });
